import addPlanDialogTemplate from './addPlanDialog/addPlanDialog.html';
import addPlanDialogController from './addPlanDialog/addPlanDialog.controller';

const planFactory = function planFactory($http, $mdDialog) {
  function getPlans() {
    return $http.get('/admin/plan').then(response => response.data);
  }
  const assign = ({ user, plan, days }) =>
    $http
      .post('/admin/user/plan', { user: user._id, plan: plan._id, days })
      .then(response => response.data);
  function showAddPlanDialog(user) {
    return $mdDialog.show({
      template: addPlanDialogTemplate,
      controller: addPlanDialogController,
      locals: {
        user,
      },
      resolve: {
        plans: getPlans,
      },
      controllerAs: '$ctrl',
    });
  }
  return { getPlans, assign, showAddPlanDialog };
};
planFactory.$inject = ['$http', '$mdDialog'];
export default planFactory;



// WEBPACK FOOTER //
// ./client/app/components/plan/plan.factory.js